const KEY = 'nudge.notifications.lastSeenMessages'

export function getLastSeenMessages(): number {
  const raw = localStorage.getItem(KEY)
  return raw ? parseInt(raw, 10) : 0
}

export function markMessagesSeen(): void {
  localStorage.setItem(KEY, String(Date.now()))
}
